import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export const constantRouterMap = [
  {
    path: '/',
    name: 'Index',
    component: () => import('@/views/Index'),
    redirect: '/cn/main?lang=en',
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import('@/views/main/redirectHome')
      },
      {
        path: '/us',
        name: 'us',
        component: () => import('@/views/us/us')
      },
      {
        path: '/login',
        name: 'login',
        component: () => import('@/views/login/login')
      },
      {
        path: '/register',
        name: 'register',
        component: () => import('@/views/login/login')
      },
      {
        path: '/practices',
        name: 'practices',
        component: () => import('@/views/exam/practices')
      },
      {
        path: '/exams',
        name: 'exams',
        component: () => import('@/views/exam/exams')
      },
      {
        path: '/exam-details',
        name: 'exam-details',
        component: () => import('@/views/exam/examDetails')
      },
      {
        path: '/exam-items',
        name: 'exam-items',
        component: () => import('@/views/exam/examItems')
      },
      {
        path: '/start-exam-a/:id',
        name: 'start-exam-a',
        component: () => import('@/views/exam/startExamA')
      },
      {
        path: '/start-exam-b/:id',
        name: 'start-exam-b',
        component: () => import('@/views/exam/startExamB')
      },
      {
        path: '/start-exam-c/:id',
        name: 'start-exam-c',
        component: () => import('@/views/exam/startExamC')
      },
      {
        path: '/exam-record',
        name: 'exam-record',
        component: () => import('@/views/exam/examRecords')
      },
      {
        path: '/knowledge',
        name: 'knowledge',
        component: () => import('@/views/exam/knowledge')
      },
      {
        path: '/practices',
        name: 'practices',
        component: () => import('@/views/exam/practices')
      },
      {
        path: '/courses',
        name: 'courses',
        component: () => import('@/views/exam/courses')
      },
      {
        path: '/course-details',
        name: 'course-details',
        component: () => import('@/views/exam/courseDetails')
      },
      {
        path: '/course-section',
        name: 'course-section',
        component: () => import('@/views/exam/section')
      },
      {
        path: '/account',
        name: 'account',
        component: () => import('@/views/personal/account')
      },
      {
        path: '/password',
        name: 'password',
        component: () => import('@/views/personal/password')
      },
      {
        path: '/incorrect',
        name: 'incorrect',
        component: () => import('@/views/exam/incorrect')
      },
      {
        path: '/reset-password',
        name: 'reset-password',
        component: () => import('@/views/personal/resetPassword')
      },
      {
        path: '/search',
        name: 'search',
        component: () => import('@/views/exam/search')
      },
      {
        path: '/collect',
        name: 'collect',
        component: () => import('@/views/collect/collect')
      },

      // sigen add
      {
        path: '/main',
        name: 'main',
        component: () => import('@/views/main/main')
      },
      // sigen add
      {
        path: '/shome',
        name: 'shome',
        component: () => import('@/views/main/shome')
      },
      {
        path: '/ssologin',
        name: 'ssologin',
        component: () => import('@/views/login/ssoLogin')
      },
      {
        path: '/video-details',
        name: 'video-details',
        component: () => import('@/views/sigen/courseDetails')
      },
      {
        path: '/notice-details',
        name: 'notice-details',
        component: () => import('@/views/sigen/notificationDetails')
      },
      {
        path: '/problem-details',
        name: 'problem-details',
        component: () => import('@/views/sigen/problemDetail')
      },
      {
        path: '/warranty-details',
        name: 'warranty-details',
        component: () => import('@/views/sigen/warrantyDetail')
      },
      {
        path: '/view-pdf',
        name: 'view-pdf',
        component: () => import('@/views/sigen/plpdf')
      }
    ]
  },
  {
    path: '/mobile',
    name: 'mobile',
    component: () => import('@/views/mobile/index')
  },
  {
    path: '*',
    redirect: '/main'
  }
]
export default new Router({
  mode: 'history',
  base: '/cn/',
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js